import { ScanModule, ScanType, Severity } from '../enums';
import { HorizonFindingDto } from './horizon-finding-dto';
import { NessusFindingDto } from './nessus-finding-dto';
import { DecaretoFindingDto } from './decareto-finding-dto';
import { BreachLenseFindingDto } from './breach-lense-finding-dto';
import { IdentecoFindingDto } from './identeco-finding-dto';

export interface FindingDto {
  scanType: ScanType;
  scanModule: ScanModule;
  score: number;
  severity: Severity;
  name: string;
  description: string;
}

export namespace FindingDto {
  export function mapFromApiValue(findingDto: any): FindingDto {
    const scanModule = ScanModule.mapFromApiValue(findingDto.scanModule);

    const scanModuleMappings: Record<ScanModule, (dto: any) => FindingDto> = {
      [ScanModule.Horizon]: HorizonFindingDto.mapFromApiValue,
      [ScanModule.Nessus]: NessusFindingDto.mapFromApiValue,
      [ScanModule.Decareto]: DecaretoFindingDto.mapFromApiValue,
      [ScanModule.BreachLense]: BreachLenseFindingDto.mapFromApiValue,
      [ScanModule.Identeco]: IdentecoFindingDto.mapFromApiValue,
    };

    const mapper = scanModuleMappings[scanModule];
    if (mapper) {
      return mapper(findingDto);
    }

    return {
      ...findingDto,
      scanType: ScanType.mapFromApiValue(findingDto.scanType),
      scanModule,
      severity: Severity.mapFromApiValue(findingDto.severity),
    };
  }
}
